import { atom } from 'recoil';

export const teacherIdState = atom({
  key: 'teacherId',
  default: 'call',
});

export const regularParticipantsIdState = atom({
  key: 'regularParticipantsId',
  default: [],
});

export const showParticipantsWindowState = atom( {
  key: 'showParticipantsWindowState',
  default: false,
})
